import React from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { ErrorContent } from 'components/errors';
import { LoadingContent } from 'components/loading';
import { useBillingType } from 'hooks/use-billing-type.hook';
import { DualBilling } from './dual-billing';
import { ArcadiaConsolidatedBilling } from './arcadia-consolidated-billing';
import { UtilityConsolidatedBilling } from './utility-consolidated-billing';
import { GET_UTILITY_INFO_FOR_BILLING } from './content.api';

export const Content = () => {
  const { planId } = useParams<{ planId?: string }>();
  const {
    data: billingTypeData,
    loading: billingTypeLoading,
    error: billingTypeError,
  } = useBillingType({ planId });
  const {
    data: utilityInfoData,
    loading: utilityInfoLoading,
    error: utilityInfoError,
  } = useQuery<
    GetUtilityInfoForBillingQuery,
    GetUtilityInfoForBillingQueryVariables
  >(GET_UTILITY_INFO_FOR_BILLING, {
    skip: !planId,
    variables: { planId: Number(planId) || -1 },
  });

  const loading = billingTypeLoading || utilityInfoLoading;
  const error = billingTypeError || utilityInfoError;

  if (loading) return <LoadingContent />;
  if (error || !billingTypeData || !utilityInfoData) return <ErrorContent />;

  const { utilityAccounts } = utilityInfoData.plan || {};
  const { isDualBilling, isUtilityConsolidatedBilling } = billingTypeData;

  if (isDualBilling) return <DualBilling />;
  if (isUtilityConsolidatedBilling)
    return <UtilityConsolidatedBilling utility={utilityAccounts[0]?.utility} />;
  return <ArcadiaConsolidatedBilling />;
};
